// extracted by mini-css-extract-plugin
export default {"ratesPage":"RatesPage_ratesPage__Dgesv","rate":"RatesPage_rate__cAmOO"};